module.exports={
	"Form": "SampleCreateManifest",
	"InitialBundle":
	[
		{
			"Type": "Custom",
			"Protocol": "HTTPS",
			"URL": "Sample/Sequence",
			"Destination": "AppData.SampleSequence"
		}
	],
	"PickLists": [
		{
			"Hash": "CreateStates",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceStates[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateCities",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCities[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateCountries",
			"ListAddress": "AppData",
			"ListSourceAddress": "SourceCountries[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateContainers",
			"ListAddress": "AppData",
			"ListSourceAddress": "Containers[]",
			"TextTemplate": "{~D:Record.Value~}",
			"IDTemplate": "{~D:Record.Hash~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		},
		{
			"Hash": "CreateLocations",
			"ListAddress": "AppData",
			"ListSourceAddress": "Locations[]",
			"TextTemplate": "{~D:Record.Name~}",
			"IDTemplate": "{~D:Record.IDLocation~}",
			"Sorted": true,
			"UpdateFrequency": "Always"
		}
	],
	"Descriptors": {
		"SampleSequence.Next": {
			"Name": "Sample Number",
			"Hash": "CreateSampleNumber",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"InputType": "ReadOnly",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Name": {
			"Name": "Description",
			"Hash": "CreateDescription",
			"DataType": "String",
			"PictForm": {
				"Required": true,
				"Row": "2",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Extension.ReceivedDate": {
			"Name": "Received On",
			"Hash": "CreateReceivedDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"Default": "today"
			}
		},
		"SampleDetails.DesignatedTime": {
			"Name": "Sampled On",
			"Hash": "CreateSampledDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Extension.Container": {
			"Name": "Container",
			"Hash": "CreateContainer",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateContainers"
			}
		},
		"SampleDetails.Extension.ContainerCount": {
			"Name": "Container Count",
			"Hash": "CreateContainerCount",
			"DataType": "Number",
			"PictForm": {
				"Row": "3",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.ReceivedFrom": {
			"Name": "Source",
			"Hash": "CreateSource",
			"DataType": "String",
			"PictForm": {
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Extension.SourceCity": {
			"Name": "Source Location City",
			"Hash": "CreateSourceLocationCity",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateCities",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-AutofillTriggerGroup"
				],
				"AutofillTriggerGroup": {
					"TriggerGroupHash": "SourceLocation",
					"SelectOptionsRefresh": true
				}
			}
		},
		"SampleDetails.Extension.SourceState": {
			"Name": "Source Location State",
			"Hash": "CreateSourceLocationState",
			"DataType": "String",
			"PictForm": {
				"InputType": "Select2",
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"AllowCustomValues": true,
				"SelectOptionsPickList": "CreateStates",
				"Providers": [
					"Pict-Input-Select",
					"Pict-Input-EntityBundleRequest",
					"Pict-Input-AutofillTriggerGroup"
				],
				"EntitiesBundle": [
					{
						"Entity": "ListDefault",
						"Filter": "FBV~Hash~EQ~{~D:Record.Value~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~State",
						"Destination": "AppData.CurrentState",
						"SingleRecord": true
					},
					{
						"Entity": "ListDefaultListDefaultJoin",
						"Filter": "FBV~ScopeIDListDefault~EQ~{~D:AppData.CurrentState.IDListDefault~}",
						"Destination": "AppData.StateCityJoins"
					},
					{
						"Entity": "ListDefault",
						"Filter": "FBL~IDListDefault~INN~{~PJU:,^IDListDefault^AppData.StateCityJoins~}~FBV~NamespaceKey~EQ~Geographical~FBV~NamespaceValue~EQ~City",
						"Destination": "AppData.SourceCities"
					}
				],
				"EntityBundleTriggerGroup": "SourceLocation"
			}
		},
		"SampleDetails.Extension.SourceCountry": {
			"Name": "Source Location Country",
			"Hash": "CreateSourceLocationCountry",
			"DataType": "String",
			"Default": "USA",
			"PictForm": {
				"InputType": "Select2",
				"AllowCustomValues": true,
				"Row": "4",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateCountries",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"LoggedBy": {
			"Name": "Logged By",
			"Hash": "CreateLoggedBy",
			"DataType": "String",
			"PictForm": {
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"Row": "5",
				"InputType": "TemplatedEntityLookup",
				"TemplatedEntityLookup":
				{
					"Template": "{~D:AppData.CreatingUser.NameFirst~} {~D:AppData.CreatingUser.NameLast~}",

					"EmptyValueTestList": ["AppData.CreatingUser"],
					"EmptyValueTemplate": "User Not Found",

					"EntitiesBundle": [
						{
							"Entity": "User",
							"Filter": "FBV~IDUser~EQ~{~D:AppData.SampleDetails.CreatingIDUser~}",
							"Destination": "AppData.CreatingUser",
							"SingleRecord": true
						}]
				}
			}
		},
		"SampleDetails.Extension.StorageLocation": {
			"Name": "Storage Location",
			"Hash": "CreateStorageLocation",
			"DataType": "Number",
			"PictForm": {
				"InputType": "Select2",
				"Row": "5",
				"Section": "SampleCreate",
				"Group": "SampleCreate",
				"SelectOptionsPickList": "CreateLocations",
				"Providers": [
					"Pict-Input-Select"
				]
			}
		},
		"SampleDetails.IDMaterial": {
			"Name": "Material",
			"Hash": "CreateMaterial",
			"DataType": "String",
			"PictForm": {
				"Row": "5",
				"InputType": "MaterialSelector",
				"Provider": [ "MaterialSelector" ],
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		},
		"SampleDetails.Notes": {
			"Name": "Notes",
			"Hash": "CreateNotes",
			"DataType": "String",
			"PictForm": {
				"InputType": "TextArea",
				"Row": "6",
				"Section": "SampleCreate",
				"Group": "SampleCreate"
			}
		}
	},
	"Sections": [
		{
			"Name": "Sample Create",
			"Hash": "SampleCreate",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Sample Create",
					"Hash": "SampleCreate",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
